export class OnceResponse {
    constructor({
        quota_status,
        imei_lock,
        activation_date,
        current_quota_SMS,
        imsi,
        ip_address,
        iccid,
        current_quota,
        quota,
        imei,
        msisdn,
        quota_status_SMS,
        status,
    }) {
        this.quotaStatus = {
            description: quota_status.description,
            id: quota_status.id,
        };
        this.imeiLock = imei_lock;
        this.activationDate = new Date(activation_date);
        this.currentQuotaSMS = current_quota_SMS;
        this.imsi = imsi;
        this.ipAddress = ip_address;
        this.iccid = iccid;
        this.currentQuota = current_quota;
        this.quota = {
            volume: quota.volume,
            lastVolumeAdded: quota.last_volume_added,
            totalVolume: quota.total_volume,
            expiryDate: new Date(quota.expiry_date),
            lastStatusChangeDate: new Date(quota.last_status_change_date),
            thresholdPercentage: quota.threshold_percentage,
            peakThroughput: quota.peak_throughput,
        };
        this.imei = imei;
        this.msisdn = msisdn;
        this.quotaStatusSMS = {
            description: quota_status_SMS.description,
            id: quota_status_SMS.id,
        };
        this.status = {
            location: {
                country: {
                    countryCode: status.location.country.country_code,
                    latitude: status.location.country.latitude,
                    name: status.location.country.name,
                    mcc: status.location.country.mcc,
                    isoCode: status.location.country.iso_code,
                    countryId: status.location.country.country_id,
                    longitude: status.location.country.longitude,
                },
                iccid: status.location.iccid,
                lastUpdated: new Date(status.location.last_updated),
                operatorId: status.location.operator_id,
                sgsnNumber: status.location.sgsn_number,
                imsi: status.location.imsi,
                sgsnNumberNp: status.location.sgsn_number_np,
                operator: {
                    country: {
                        name: status.location.operator.country.name,
                        id: status.location.operator.country.id,
                        isoCode: status.location.operator.country.iso_code,
                    },
                    name: status.location.operator.name,
                    id: status.location.operator.id,
                },
                lastUpdatedGprs: new Date(status.location.last_updated_gprs),
                sgsnIpAddress: status.location.sgsn_ip_address,
            },
            services: [...status.services],
            status: status.status,
            pdpContext: status.pdp_context
                ? {
                    tariffId: status.pdp_context.tariff_id,
                    ggsnControlPlaneIpAddress: status.pdp_context.ggsn_control_plane_ip_address,
                    operatorId: status.pdp_context.operator_id,
                    endpointId: status.pdp_context.endpoint_id,
                    ratezoneId: status.pdp_context.ratezone_id,
                    imsi: status.pdp_context.imsi,
                    mcc: status.pdp_context.mcc,
                    lac: status.pdp_context.lac,
                    duration: status.pdp_context.duration,
                    pdpContextId: status.pdp_context.pdp_context_id,
                    organisationId: status.pdp_context.organisation_id,
                    teidDataPlane: status.pdp_context.teid_data_plane,
                    sgsnControlPlaneIpAddress: status.pdp_context.sgsn_control_plane_ip_address,
                    sac: status.pdp_context.sac,
                    rac: status.pdp_context.rac,
                    tariffProfileId: status.pdp_context.tariff_profile_id,
                    mnc: status.pdp_context.mnc,
                    created: new Date(status.pdp_context.created),
                    ci: status.pdp_context.ci,
                    ueIpAddress: status.pdp_context.ue_ip_address,
                    sgsnDataPlaneIpAddress: status.pdp_context.sgsn_data_plane_ip_address,
                    teidControlPlane: status.pdp_context.teid_control_plane,
                    ggsnDataPlaneIpAddress: status.pdp_context.ggsn_data_plane_ip_address,
                    ratType: {
                        ratTypeId: status.pdp_context.rat_type.rat_type_id,
                        description: status.pdp_context.rat_type.description,
                    },
                    imsiId: status.pdp_context.imsi_id,
                    simId: status.pdp_context.sim_id,
                    nsapi: status.pdp_context.nsapi,
                    imeisv: status.pdp_context.imeisv,
                    gtpVersion: status.pdp_context.gtp_version,
                }
                : undefined,
        };
    }

    static fromObject(obj) {
        return new OnceResponse(obj);
    }
}

export class SimpleOnceResponse {
    constructor(onceResponse) {
        const { status, quota } = onceResponse ?? {};

        this.operatorName = status?.location?.operator?.name || null;
        this.countryName = status?.location?.country?.name || null;
        this.longitude = status?.location?.country?.longitude || null;
        this.latitude = status?.location?.country?.latitude || null;
        this.quotaVolume = quota?.volume || null;
        this.totalVolume = quota?.totalVolume || null;
        this.radioAccessTech =
          status?.pdpContext?.ratType?.description || null;
    }

    static fromOnceResponse(onceResponse) {
        return new SimpleOnceResponse(onceResponse);
    }
}

// Example usage:
const jsonData = {
    "quota_status": {
        "description": "More than 20% available",
        "id": 0
    },
    "imei_lock": false,
    "activation_date": "2023-03-10T13:03:43.000+0000",
    "current_quota_SMS": 0,
    "imsi": "901405104436073",
    "ip_address": "10.249.162.1",
    "iccid": "8988228066604436073",
    "current_quota": 9000,
    "quota": {
        "volume": 592.982529,
        "last_volume_added": 1247,
        "total_volume": 9000,
        "expiry_date": "2026-06-10 00:00:00",
        "last_status_change_date": "2023-11-07 15:05:43",
        "threshold_percentage": 20,
        "peak_throughput": 128000
    },
    "imei": "3569958485154004",
    "msisdn": "882285104436073",
    "quota_status_SMS": {
        "description": "More than 20% available",
        "id": 0
    },
    "status": {
        "pdp_context": {
            "tariff_id": "442",
            "ggsn_control_plane_ip_address": "10.70.79.50",
            "operator_id": "61",
            "endpoint_id": "15884995",
            "ratezone_id": "2172",
            "imsi": "901405104436073",
            "mcc": "222",
            "lac": "30072",
            "duration": "00:19:54",
            "pdp_context_id": "15223813841",
            "organisation_id": "48251",
            "teid_data_plane": "609895692",
            "sgsn_control_plane_ip_address": "10.128.0.244",
            "sac": "0",
            "rac": "0",
            "tariff_profile_id": "211646",
            "mnc": "10",
            "created": "2023-11-15 08:35:00",
            "ci": "57121",
            "ue_ip_address": "10.249.162.1",
            "sgsn_data_plane_ip_address": "10.128.0.156",
            "teid_control_plane": "1818158854",
            "ggsn_data_plane_ip_address": "10.70.79.127",
            "rat_type": {
                "rat_type_id": "2",
                "description": "2G"
            },
            "imsi_id": "5855607",
            "sim_id": "5121670",
            "nsapi": "5",
            "imeisv": "3569958485154004",
            "gtp_version": "1"
        },
        "location": {
            "country": {
                "country_code": "39",
                "latitude": "42.833300",
                "name": "Italy",
                "mcc": "222",
                "iso_code": "it",
                "country_id": "98",
                "longitude": "12.833300"
            },
            "last_updated": "2023-11-03 07:57:05",
            "operator_id": "61",
            "sgsn_number": "393492003029",
            "imsi": "901405104436073",
            "vlr_number": "393492000104",
            "sgsn_number_np": "1",
            "operator": {
                "country": {
                    "name": "Italy",
                    "id": 98,
                    "iso_code": "it"
                },
                "name": "Vodafone Omnitel",
                "id": 61
            },
            "iccid": "8988228066604436073",
            "vlr_number_np": "1",
            "msc_number_np": "1",
            "msc": "393492000104",
            "last_updated_gprs": "2023-10-27 18:44:29",
            "sgsn_ip_address": "83.224.36.170"
        },
        "services": [
            "GPRS"
        ],
        "status": "ONLINE"
    }
};

// Example usage:
const jsonData2 = {
    "quota_status": {
        "description": "More than 20% available",
        "id": 0
    },
    "imei_lock": false,
    "activation_date": "2022-12-07T16:31:46.000+0000",
    "current_quota_SMS": 250,
    "imsi": "901405102077053",
    "ip_address": "10.138.21.1",
    "iccid": "8988228066602077053",
    "current_quota": 500,
    "quota": {
        "volume": 498.913957,
        "last_volume_added": 499,
        "total_volume": 500,
        "expiry_date": "2032-07-12 00:00:00",
        "last_status_change_date": "2022-12-07 16:32:02",
        "threshold_percentage": 20,
        "peak_throughput": 128000
    },
    "imei": "3569958456817704",
    "msisdn": "882285102077053",
    "quota_status_SMS": {
        "description": "More than 20% available",
        "id": 0
    },
    "status": {
        "location": {
            "country": {
                "country_code": "39",
                "latitude": "42.833300",
                "name": "Italy",
                "mcc": "222",
                "iso_code": "it",
                "country_id": "98",
                "longitude": "12.833300"
            },
            "iccid": "8988228066602077053",
            "last_updated": "2023-02-02 03:23:39",
            "operator_id": "61",
            "sgsn_number": "393492008026",
            "imsi": "901405102077053",
            "sgsn_number_np": "1",
            "operator": {
                "country": {
                    "name": "Italy",
                    "id": 98,
                    "iso_code": "it"
                },
                "name": "Vodafone Omnitel",
                "id": 61
            },
            "last_updated_gprs": "2023-01-27 13:54:08",
            "sgsn_ip_address": "83.224.36.173"
        },
        "services": [
            "GPRS"
        ],
        "status": "ATTACHED"
    }
};

const onceResponseObj = OnceResponse.fromObject(jsonData);
const onceResponseObj2 = OnceResponse.fromObject(jsonData2);

const simpleResponseObj = SimpleOnceResponse.fromOnceResponse(onceResponseObj);
const simpleResponseObj2 = SimpleOnceResponse.fromOnceResponse(onceResponseObj2);

console.log(simpleResponseObj);
console.log(simpleResponseObj2);
